/* RUW 2026-10-16 · VTILTED "Represent" layer behaviour. No dependencies. */
(function () {
  'use strict';
  var doc = document.documentElement;

  /* ---- header: solid + pinned once the offer bar has scrolled away ---- */
  var bar = document.querySelector('[data-rp-bar]');
  var header = document.querySelector('[data-rp-header]');
  function onScroll() {
    var limit = bar ? bar.offsetHeight : 0;
    doc.classList.toggle('rp-scrolled', window.scrollY > limit);
  }
  if (header) {
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    // white header while a dropdown is open (desktop)
    header.querySelectorAll('.rp-nav__item--mega').forEach(function (item) {
      item.addEventListener('mouseenter', function () { header.classList.add('is-mega'); });
      item.addEventListener('mouseleave', function () { header.classList.remove('is-mega'); });
      item.addEventListener('focusin', function () { header.classList.add('is-mega'); });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) header.classList.remove('is-mega'); });
    });
  }

  /* ---- offer bar: rotate messages ---- */
  if (bar) {
    var msgs = bar.querySelectorAll('.rp-bar__msg');
    if (msgs.length > 1) {
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, 4200);
    }
  }

  /* ---- phone menu sheet ---- */
  var drawer = document.querySelector('[data-rp-drawer]');
  function setPanel(name) {
    if (!drawer) return;
    drawer.querySelectorAll('[data-rp-panel]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-rp-panel') === name);
    });
  }
  function openDrawer() {
    if (!drawer) return;
    setPanel('root');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    doc.classList.add('rp-lock');
    document.querySelectorAll('[data-rp-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    doc.classList.remove('rp-lock');
    document.querySelectorAll('[data-rp-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-rp-menu-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-rp-menu-close]')) { e.preventDefault(); closeDrawer(); return; }
    var go = t.closest('[data-rp-go]');
    if (go) { e.preventDefault(); setPanel(go.getAttribute('data-rp-go')); return; }

    /* product card "+" → size row */
    var plus = t.closest('[data-rp-plus]');
    if (plus) {
      e.preventDefault();
      var card = plus.closest('[data-rp-card]');
      var open = !card.classList.contains('is-quick');
      document.querySelectorAll('[data-rp-card].is-quick').forEach(function (c) {
        c.classList.remove('is-quick');
        var b = c.querySelector('[data-rp-plus]'); if (b) b.setAttribute('aria-expanded', 'false');
      });
      card.classList.toggle('is-quick', open);
      plus.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (!t.closest('[data-rp-card]')) {
      document.querySelectorAll('[data-rp-card].is-quick').forEach(function (c) { c.classList.remove('is-quick'); });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });
  // close the sheet when the theme's search drawer is opened from it
  document.addEventListener('click', function (e) {
    if (e.target.closest('.rp-drawer .thb-quick-search')) closeDrawer();
  });
  // collapse the size row once an item is added (theme fires this)
  document.addEventListener('cart:item-added', function () {
    document.querySelectorAll('[data-rp-card].is-quick').forEach(function (c) { c.classList.remove('is-quick'); });
  });

  /* ---- product rows: arrow buttons ---- */
  document.querySelectorAll('[data-rp-rail]').forEach(function (rail) {
    var track = rail.querySelector('[data-rp-rail-track]');
    var prev = rail.querySelector('[data-rp-rail-prev]');
    var next = rail.querySelector('[data-rp-rail-next]');
    if (!track) return;
    function step() { return Math.max(track.clientWidth * 0.8, 240); }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ---- campaign countdown: 04D:16H:01M:45S ---- */
  document.querySelectorAll('[data-rp-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-rp-countdown')).getTime();
    if (isNaN(end)) return;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      el.textContent = pad(d) + 'D:' + pad(h) + 'H:' + pad(m) + 'M:' + pad(s) + 'S';
    }
    tick();
    setInterval(tick, 1000);
  });
  /* ---- collection description: read more ---- */
  document.querySelectorAll('[data-rp-more-btn]').forEach(function (b) {
    b.addEventListener('click', function () {
      var box = b.closest('[data-rp-more]'); var open = box.classList.toggle('is-open');
      b.textContent = open ? 'read less' : 'read more';
    });
  });
  /* ---- search panel (Represent) ---- */
  var sp = document.querySelector('[data-rp-search]');
  if (sp) {
    var sInput = sp.querySelector('[data-rp-search-input]');
    var sForm = sp.querySelector('[data-rp-search-form]');
    var sClear = sp.querySelector('[data-rp-search-clear]');
    var sAll = sp.querySelector('[data-rp-search-all]');
    var sResults = sp.querySelector('[data-rp-results]');
    var sSuggestWrap = sp.querySelector('[data-rp-suggest-wrap]');
    var sSuggest = sp.querySelector('[data-rp-suggest]');
    var sColsWrap = sp.querySelector('[data-rp-cols-wrap]');
    var sCols = sp.querySelector('[data-rp-cols]');
    var states = sp.querySelectorAll('[data-rp-state]');
    var timer = null, ctrl = null, lastQ = '', activeSize = '';
    var esc = function (t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var setState = function (n) { states.forEach(function (st) { st.classList.toggle('is-active', st.getAttribute('data-rp-state') === n); }); };
    var revealIn = function (root) {
      var items = root.querySelectorAll('.rp-reveal');
      requestAnimationFrame(function () { requestAnimationFrame(function () { items.forEach(function (el) { el.classList.add('is-in'); }); }); });
    };
    var openSearch = function (prefill) {
      var hdr = document.querySelector('[data-rp-header]');
      var top = hdr ? Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) : 0;
      sp.style.setProperty('--rp-search-top', top + 'px');
      if (typeof closeDrawer === 'function') closeDrawer();
      doc.classList.add('rp-search-open');
      sp.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () { sp.classList.add('is-open'); });
      if (typeof prefill === 'string') { sInput.value = prefill; onType(); }
      setTimeout(function () { try { sInput.focus({ preventScroll: true }); } catch (e) { sInput.focus(); } }, 60);
    };
    var closeSearch = function () {
      sp.classList.remove('is-open');
      sp.setAttribute('aria-hidden', 'true');
      doc.classList.remove('rp-search-open');
      sInput.blur();
    };
    var applySize = function (size) {
      activeSize = size;
      sp.querySelectorAll('[data-rp-size]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-rp-size') === size && size !== ''); });
      var items = sResults.querySelectorAll('[data-rp-sizes]'), shown = 0;
      items.forEach(function (li) {
        var ok = !size || (li.getAttribute('data-rp-sizes') || '').indexOf(',' + size + ',') > -1;
        li.hidden = !ok; if (ok) shown++;
      });
      var none = sResults.querySelector('[data-rp-nosize]');
      if (none) none.hidden = !(size && items.length && shown === 0);
    };
    var render = function (q, html, sugg) {
      // suggestions + collections from predictive search
      var queries = (sugg && sugg.resources && sugg.resources.results && sugg.resources.results.queries) || [];
      var cols = (sugg && sugg.resources && sugg.resources.results && sugg.resources.results.collections) || [];
      sSuggest.innerHTML = queries.slice(0, 6).map(function (x) { return '<button type="button" class="rp-chip" data-rp-term="' + esc(x.text) + '">' + (x.styled_text || esc(x.text)) + '</button>'; }).join('');
      sSuggestWrap.hidden = !queries.length;
      sCols.innerHTML = cols.slice(0, 5).map(function (c) { return '<li><a href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>'; }).join('');
      sColsWrap.hidden = !cols.length;
      // results grid (real product cards from the section render)
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var sr = tmp.querySelector('.rp-sr');
      sResults.innerHTML = sr ? sr.outerHTML : '';
      var count = sr ? parseInt(sr.getAttribute('data-rp-count') || '0', 10) : 0;
      sAll.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search?type=product&q=' + encodeURIComponent(q);
      sAll.textContent = count > 0 ? 'See all (' + count + ') search results' : 'See all search results';
      sAll.hidden = count === 0;
      requestAnimationFrame(function () { sAll.classList.toggle('is-on', count > 0); });
      if (activeSize) applySize(activeSize);
      revealIn(sResults);
    };
    var run = function (q) {
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      var opt = ctrl ? { signal: ctrl.signal } : {};
      var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      sp.classList.add('is-loading');
      var a = fetch(root + 'search?type=product&options%5Bprefix%5D=last&section_id=rp-search-results&q=' + encodeURIComponent(q), opt).then(function (r) { return r.text(); });
      var b = fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=query,collection&resources[limit]=6', opt).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      Promise.all([a, b]).then(function (res) { if (q === lastQ) render(q, res[0], res[1]); })
        .catch(function () {})
        .finally(function () { if (q === lastQ) sp.classList.remove('is-loading'); });
    };
    var onType = function () {
      var q = sInput.value.trim();
      sClear.hidden = !sInput.value;
      clearTimeout(timer);
      if (!q) {
        lastQ = ''; setState('idle'); sAll.classList.remove('is-on'); sAll.hidden = true; sp.classList.remove('is-loading');
        return;
      }
      setState('live');
      lastQ = q;
      timer = setTimeout(function () { run(q); }, 220);
    };
    sInput.addEventListener('input', onType);
    sForm.addEventListener('submit', function (e) { if (!sInput.value.trim()) e.preventDefault(); });
    sClear.addEventListener('click', function () { sInput.value = ''; onType(); sInput.focus(); });

    document.addEventListener('click', function (e) {
      var t = e.target;
      var opener = t.closest('[data-rp-search-open]');
      if (opener) { e.preventDefault(); openSearch(); return; }
      if (t.closest('[data-rp-search-close]')) { e.preventDefault(); closeSearch(); return; }
      var term = t.closest('[data-rp-term]');
      if (term && sp.contains(term)) { e.preventDefault(); sInput.value = term.getAttribute('data-rp-term'); onType(); sInput.focus(); return; }
      var sz = t.closest('[data-rp-size]');
      if (sz && sp.contains(sz)) { e.preventDefault(); var v = sz.getAttribute('data-rp-size'); applySize(activeSize === v ? '' : v); return; }
      if (t.closest('[data-rp-size-reset]')) { e.preventDefault(); applySize(''); }
    });
    // phone menu: tapping its search field hands over to the search sheet
    document.querySelectorAll('.rp-drawer__search input[type="search"]').forEach(function (inp) {
      inp.addEventListener('focus', function () { inp.blur(); openSearch(inp.value); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sp.classList.contains('is-open')) closeSearch();
      if (e.key === '/' && !sp.classList.contains('is-open') && !/input|textarea|select/i.test((document.activeElement || {}).tagName || '')) { e.preventDefault(); openSearch(); }
    });
  }
})();
